import React from 'react'
import CommingSoon from '../../../components/CommingSoon'

function Sustainability() {
  return (
    <div style={{width:'100vw',overflowX:'hidden'}}><CommingSoon/></div>
  )
}

export default Sustainability